var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M41.048 24.379a1.252 1.252 0 0 0-.154-1.562L28.632 10.555a1.238 1.238 0 0 0-1.751 1.751l10.147 10.148H-5.525a1.239 1.239 0 0 0-1.223 1.254 1.239 1.239 0 0 0 1.223 1.223h42.553L26.88 35.078a1.238 1.238 0 0 0 1.751 1.751l12.262-12.261a1.222 1.222 0 0 0 .155-.189z","transform":"translate(6.748 -10.192)"}));
}

RightArrow.defaultProps = {"width":"48","height":"27","viewBox":"0 0 48 27"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
